import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    locationData: {}, // 定位信息
    mapFlag: true // 高度地图只能实例化一次
  },
  mutations: {
    // 存储当前定位信息
    setLocationFunc (state, payload) {
      state.locationData = payload
    },
    // 删除定位信息
    delLocationInfo (state, payload) {
      state.locationData = payload
    },
    // 设置高德地图插件已经添加过就不在添加了
    setMapFlag (state, payload) {
      state.mapFlag = payload
    }
  },
  actions: {
  },
  modules: {
  }
})
